import { IBadgeProps } from '@bimser/core';
import { Badge } from 'antd';

const BCBadge = (props: IBadgeProps) => {
	const {
		title,
		count,
		dot,
		offset,
		overflowCount,
		showZero,
		status,
		text,
		children,
		style,
		color
	} = props;

	return (
		<Badge
			title={title}
			count={count}
			dot={dot}
			offset={offset}
			overflowCount={overflowCount}
			showZero={showZero}
			status={status}
			text={text}
			style={style}
			color={color}
		>
			{children}
		</Badge>
	);
};
export default BCBadge;
export { IBadgeProps };
